<div class="footer-container">
  <div class="row h-100">
    <div class="col d-flex footer-content align-items-end">Living Meaningfully © {{ currentYear }}</div>
    <div class="col d-flex justify-content-end align-items-end">
      <a href="https://chidalusoftware.ca/" class="text-decoration-none" target="_blank">
        <span class="footer-content">Powered by Chidalu</span>
      </a>
    </div>
  </div>
</div>
